import { ShieldAlert } from 'lucide-react'

/**
 * Standing safety note for the Leak Sites page (KAN-224).
 *
 * Frames public ransomware extortion posts as defensive OSINT, not hidden
 * PII, while making the guard-rail explicit: dangerous destinations never
 * auto-open and require a conscious, guarded action. Rendered as a quiet
 * amber advisory, not an alarm.
 */
export function LeakSitesSafetyNote() {
  return (
    <div
      role="note"
      aria-label="Leak site safety guidance"
      className="flex items-start gap-2.5 rounded-md border border-amber-500/30 bg-amber-500/5 px-3.5 py-2.5 text-xs leading-relaxed text-amber-800 dark:text-amber-200"
    >
      <ShieldAlert
        className="mt-0.5 h-3.5 w-3.5 flex-none text-amber-600 dark:text-amber-400"
        aria-hidden="true"
      />
      <span>
        Public extortion posts are shown for defensive analysis — victim
        identifiers here are open-source intelligence, not hidden PII. Source
        and leak URLs never auto-open: they require an explicit reveal, and you
        should only open them inside a separate, hardened browsing context.
      </span>
    </div>
  )
}
